import { render, staticRenderFns } from "./ClientsTable.vue?vue&type=template&id=725f6500&scoped=true"
import script from "./ClientsTable.vue?vue&type=script&lang=ts"
export * from "./ClientsTable.vue?vue&type=script&lang=ts"
import style0 from "./ClientsTable.vue?vue&type=style&index=0&id=725f6500&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "725f6500",
  null
  
)

export default component.exports